import { defineStore } from "pinia";
import { ref, computed } from "vue";
import api from "@/services/api";

export const useAuthStore = defineStore("auth", () => {
	const user = ref(null);
	const isLoading = ref(false);
	const error = ref(null);

	const isAuthenticated = computed(() => !!user.value);

	const checkAuthStatus = async () => {
		try {
			isLoading.value = true;
			error.value = null;

			const response = await api.get("/auth/status");

			if (response.data.isAuthenticated) {
				user.value = response.data.user;
			} else {
				user.value = null;
			}
		} catch (err) {
			console.error("Auth status check failed:", err);
			user.value = null;
			error.value = "Failed to check authentication status";
		} finally {
			isLoading.value = false;
		}
	};
	const login = () => {
		// Redirect to Google OAuth. Relative by default — in prod, client and
		// server are the same Cloud Run origin (see api.js for the same
		// reasoning); VITE_API_URL overrides for local dev's separate origins.
		const apiBaseUrl = import.meta.env.VITE_API_URL || "";
		window.location.href = `${apiBaseUrl}/api/auth/google`;
	};

	const logout = async () => {
		try {
			isLoading.value = true;
			error.value = null;

			await api.post("/auth/logout");
			user.value = null;

			// Redirect to login page
			window.location.href = "/login";
		} catch (err) {
			console.error("Logout failed:", err);
			error.value = "Failed to logout";
		} finally {
			isLoading.value = false;
		}
	};

	const updateUser = (userData) => {
		if (user.value) {
			user.value = { ...user.value, ...userData };
		}
	};

	return {
		user,
		isLoading,
		error,
		isAuthenticated,
		checkAuthStatus,
		login,
		logout,
		updateUser,
	};
});
